
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">虚拟交互数字人：个性化互动的未来趋势</h2>
                    <div class="time">2023-07-03 10:00:10</div>
                    <div class="start">
                        在当今数字化时代，虚拟交互数字人成为了引领技术发展和个性化互动的新趋势。深圳羽迹科技有限公司在这一领域中扮演着重要的角色，通过其创新的技术和前瞻性的产品，为用户带来了全新的互动体验。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/207.png" alt="1.虚拟交互数字人：个性化互动的未来趋势" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            虚拟交互数字人是指通过人工智能和图像算法等技术，将数字人物以逼真的形象呈现在虚拟空间中，并赋予其与用户进行个性化互动的能力。羽迹科技的虚拟交互数字人产品在外貌、动作、语音和情感等方面都表现出令人惊叹的真实度和自然度。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            这项技术的应用领域广泛。在娱乐和游戏领域，虚拟交互数字人可以成为玩家的个性化互动伙伴，通过语音识别和情感识别技术，实现真实而多样化的对话和互动体验。在教育和培训领域，虚拟交互数字人可以成为学生的虚拟导师，提供个性化的学习指导和反馈。在商业和客户服务领域，虚拟交互数字人可以代表企业与客户进行智能化对话和咨询。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            虚拟交互数字人的未来趋势是个性化互动的进一步发展。羽迹科技致力于不断提升虚拟交互数字人的智能化程度和个性化定制能力。通过深度学习和情感识别等技术手段，羽迹科技的产品能够更好地理解用户的需求和情感，从而提供更加贴近用户个性化要求的互动体验。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            此外，虚拟交互数字人的潜力还未完全发掘。随着技术的进一步演进，虚拟交互数字人有望在医疗领域、智能家居、社交媒体等领域发挥更大的作用，为用户带来更多智能化和个性化的服务。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            深圳羽迹科技有限公司作为虚拟交互数字人领域的领军企业，不断推动着这项技术的发展和创新。通过持续的研发和应用探索，羽迹科技将引领个性化互动的未来趋势，为用户创造更加智能、真实、个性化的数字化体验。
                        </div>
                    </div>


                    <div class="end">
                        总而言之，虚拟交互数字人代表着个性化互动的未来趋势。深圳羽迹科技有限公司在这一领域的积极探索和创新为我们展示了数字技术的无限可能性，让我们期待着在不久的将来能够享受到更加智能化和个性化的虚拟交互体验。
                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "虚拟形象与直播的元宇宙社交?-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "虚拟形象与直播的元宇宙社交?,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "二次元文化随着Z世代消费力量的崛起，也逐渐突破小众圈层走进品牌营销的大众视野",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo207.vue